module.exports = __webpack_public_path__ + "img/bell2.71eb2534.svg";